import React, { Component } from 'react';
import PropTypes from 'prop-types';

import BorderedButton from '../borderedButton/BorderedButton';

import './AnnouncementBanner.css';

class AnnouncementBanner extends Component {
  constructor() {
    super();

    this.state = {
      isOpen: false,
    };
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  onCloseClick() {
    this.setState({ isOpen: false });
  }

  render() {
    const { isOpen } = this.state;

    if (!isOpen) {
      return null;
    }

    const { text, buttonTitle, buttonLink } = this.props;
    return (
      <div id="announcement-banner">
        <button type="button" id="close-btn" onClick={this.onCloseClick}>
          <span role="img" aria-label="close">&#10005;</span>
        </button>
        <p>{text}</p>
        <BorderedButton
          title={buttonTitle}
          href={buttonLink}
          monoMode
        />
      </div>
    );
  }
}

AnnouncementBanner.propTypes = {
  text: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  buttonLink: PropTypes.string.isRequired,
};

export default AnnouncementBanner;
